import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
import DiscussionsUserPage from 'flarum/forum/components/DiscussionsUserPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';

export default () => {
  override(DiscussionsUserPage.prototype, 'show', function (original, user) {
    if (!app.forum.attribute('byobu.userpage-hidePrivate')) {
      original(user);
    } else {
      this.user = user;

      app.current.set('user', user);

      app.setTitle(user.displayName());

      m.redraw();

      this.state = new DiscussionListState({
        filter: { q: `author:${user.username()} is:discussion` },
        sort: 'newest',
      });

      this.state.refresh();
    }
  });
};
